/**
 * @Author: WangZhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:07:39
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageTextCheck.js
 * @Description: 文本变体检测
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import {fetchVariantCheck} from '../../actions/productAction';
import './pageTextCheck.less';
import {bAntiBotSend} from '../../util';

let dataCiting = [
    {
        title: '案例一',
        text: '需要小妹滋源的,去薇博搜用户名→美女店主'
    },
    {
        title: '案例二',
        text: '⽹网≤占:ẓẓĝẑẕ1 cοm �͆ � ,, ,,, ,,, 清明时节⾬雨纷纷，路路上⾏行行⼈人欲断魂。借问酒家何处有，牧童遥指杏花村。'
    },
    {
        title: '案例三',
        text: '置换3裙 5己4030还58042，tongxie们 来捡漏w'
    }
];

class PageTextCheck extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object,
        fetchVariantCheck: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            pageObj: null,
            error: '',
            textVal: ''
        };
    }

    componentDidMount() {
    }

    checkFn = () => {
        let {textVal} = this.state;
        if (!textVal) {
            this.setState({
                error: '请输入要检测的内容'
            });
            return false;
        }

        if (textVal.length > 120) {
            this.setState({
                error: '超出字数限制'
            });
            return;
        }

        this.setState({
            error: false
        });

        /* eslint-disable */
        bAntiBotSend();
        if (window['__abbaidu_2024_cb']) {
            window['__abbaidu_2024_cb'] = async responseData => {
                let companyJson = new FormData();

                companyJson.append('text', textVal);

                let localData = JSON.parse(responseData);
                if (localData && localData.data) {
                    companyJson.data = localData.data;
                    companyJson.append('data', localData.data);
                }
                if (localData && localData.key_id) {
                    companyJson.append('key_id', localData['key_id']);
                }
                if (localData && localData.sign) {
                    companyJson.append('sign', localData['sign']);
                }

                this.props.fetchVariantCheck(companyJson).then(data => {
                    if (data.status === 0) {
                        this.setState({
                            pageObj: data.data[0],
                            error: ''
                        });
                    } else {
                        this.setState({
                            pageObj: null,
                            error: data.description
                        });
                    }
                });
            };
        }
        /* eslint-enable */
    };

    render() {
        const bannerInfo = this.props.bannerInfo || {};
        let {textVal, error, pageObj} = this.state;

        let adScore = 0;
        let urlScore = 0;
        let contactScore = 0;

        if (pageObj) {
            adScore = (pageObj.adv_ad_score * 100).toFixed(0);
            urlScore = (pageObj.adv_url_score * 100).toFixed(0);
            contactScore = (pageObj.adv_contact_score * 100).toFixed(0);
        }

        let len = 120 - textVal.length;

        if (len < 0) {
            len = 0;
        }

        return (
            <div className={'product pageTextCheck'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    {bannerInfo.bannerNote}
                </div>

                <div className={'tc-bg-mod'}>
                    <div className={'product-mod'}>
                        <ProductTitle title={'产品功能'}/>
                    </div>
                    <div className={'product-mod tc-mod1'}>
                        <div>
                            <div className={'title'}>变体广告检测</div>
                            <div className={'text'}>检测待审核文本中是否包含变体广告</div>
                        </div>
                        <div>
                            <div className={'title'}>变体网址检测</div>
                            <div className={'text'}>检测待审核文本中是否包含变体⽹址</div>
                        </div>
                        <div>
                            <div className={'title'}>变体联系方式</div>
                            <div className={'text'}>检测待审核文本中是否包含变体联系⽅式</div>
                        </div>
                    </div>
                    <div className={'product-mod'}>
                        <ProductTitle title={'功能演示'}/>
                        <div className={'tc-mod2'}>
                            <div className={'nav'}>
                                {
                                    dataCiting.map((item, index) => {
                                        return <div
                                            key={index}
                                            className={textVal === item.text ? 'on' : ''}
                                            onClick={() => {
                                                this.setState({
                                                    textVal: item.text,
                                                    pageObj: null
                                                }, () => {
                                                    this.checkFn();
                                                });
                                            }}
                                        >
                                            {item.title}
                                        </div>;

                                    })
                                }
                            </div>
                            <div className={'pr'}>
                                <div className={'textarea'}>
                                    <textarea
                                        placeholder={'请输入文本或选择案例进行检测'}
                                        value={textVal}
                                        onChange={ev => {
                                            this.setState({
                                                textVal: ev.target.value,
                                                error: ev.target.value.length > 120 ? '超出字数限制' : ''
                                            });
                                        }}
                                    />
                                </div>

                                <div className={'count'}>
                                    <span>{len}</span>
                                    {
                                        textVal.length
                                            ? <i
                                                onClick={() => {
                                                    this.setState({
                                                        textVal: '',
                                                        pageObj: null
                                                    });
                                                }}
                                            />
                                            : null
                                    }

                                </div>
                            </div>
                            {
                                pageObj
                                    ? <div className={'resMod'}>
                                        <div>
                                            <span>变体广告</span>
                                            <span className={adScore >= 50 ? 'high' : ''}>{adScore}%</span>
                                        </div>
                                        <div>
                                            <span>变体网址</span>
                                            <span className={urlScore >= 50 ? 'high' : ''}>{urlScore}%</span>
                                        </div>
                                        <div>
                                            <span>变体联系方式</span>
                                            <span className={contactScore >= 50 ? 'high' : ''}>{contactScore}%</span>
                                        </div>
                                    </div>
                                    : null
                            }

                            {
                                error ? <div className={'error'}>{error}</div> : null
                            }

                            <div
                                className={'m-btn'}
                                onClick={() => {
                                    this.checkFn();
                                }}
                            >
                                检测
                            </div>

                        </div>
                    </div>
                </div>


                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'}/>
                </div>

                <div className={'product-mod'}>
                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTextCheck/pic_01.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            社区论坛
                        </div>
                        <div className={'pro-app-content'}>
                            对社区论坛发帖、回帖和站内信等文字进行检测，发现其中包含的变体广告、网址和联系方式等异常内容。
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTextCheck/pic_02.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            直播/信息流
                        </div>
                        <div className={'pro-app-content'}>
                            对直播弹幕、私信和信息流评论等文字进行检测，发现其中包含的变体广告、网址和联系方式等异常内容。
                        </div>
                    </div>

                    <div
                        className={'pro-applicable'}
                        style={{backgroundImage: `url(${require('../../asset/image/pageTextCheck/pic_03.png')})`}}
                    >
                        <div className={'pro-app-title'}>
                            即时通信
                        </div>
                        <div className={'pro-app-content'}>
                            对即时通信内容、短信内容等文字进行检测，发现其中包含的变体广告、网址和联系方式等异常内容。
                        </div>
                    </div>
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'产品特色'}/>
                </div>

                <div className={'product-mod'}>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTextCheck/icon_1.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>持续领先的检测技术</div>
                            <div className={'proinfo-box-des'}>
                                依托百度业界领先的⼈工智能技术，不断提升对文本变体的检测能力，在保证准确率的前提下，持续增加对各种形式变体文本的召回能力
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTextCheck/icon_2.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>识别准确率高</div>
                            <div className={'proinfo-box-des'}>
                                基于深度学习的智能检测技术以及长期积累的海量变体文本数据，准确率高达99.5%以上
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTextCheck/icon_3.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>持续对抗</div>
                            <div className={'proinfo-box-des'}>
                                在与一线黑灰产对抗的过程中，持续⻓提升模型对各种新型变体的检测能力
                            </div>
                        </div>
                    </div>
                    <div className={'proinfo-box mui-flex'}>
                        <div className={'proinfo-box-icon'}>
                            <img
                                src={require('../../asset/image/pageTextCheck/icon_4.svg')}
                                width={'100%'}
                            />
                        </div>
                        <div className={'cell'}>
                            <div className={'proinfo-box-title'}>灵活的接⼊方式</div>
                            <div className={'proinfo-box-des'}>
                                支持快速⽅便的WEB API或SDK调用，提供根据业务场景和需求适配的行业解决方案
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}

function mapDispatchToProps() {
    return {
        fetchVariantCheck: obj => fetchVariantCheck(obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageTextCheck);



// WEBPACK FOOTER //
// ./src/containers/product/pageTextCheck.js